import { defineMessages } from 'react-intl-next';

const messages: {
	dialogAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dialogAriaLabel: {
		id: 'ai-mate.chat-input.aria-label',
		defaultMessage: 'Rovo chat dialog',
		description: 'Aria label for the Rovo chat input',
	},
});

export default messages;
